import React, { useContext, useEffect, useState } from "react";
import { message, Button, Input, Form } from "antd";
import { RootContext } from "../../../RootContextProvider";
import { updateAccountName } from "../../../utils/account";
import { verticalFormLayout } from "../../../utils/forms";

const AdminAccount = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const { account, setAccount } = useContext(RootContext);

  useEffect(() => {
    form.setFieldsValue({
      accountname: account.AccountName,
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      let updatedAccount = await updateAccountName(
        account.AccountID,
        values.accountname
      );
      setAccount(updatedAccount);
      message.success("Informations mises à jour avec succès");
      setLoading(false);
    } catch (e) {
      message.error("Erreur lors de la sauvegarde");
      setLoading(false);
    }
  };

  const onFinishFailed = () => {};

  return (
    <div className="block-section">
      <div className="container-settings" style={{ marginTop: "20px" }}>
        <div className="third-title social">Informations sur votre compte</div>
        <Form
          className="align-left"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          {...verticalFormLayout}
        >
          <Form.Item
            label="Nom de votre compte"
            name="accountname"
            rules={[
              { required: true, message: "Insérez le nom de votre compte" },
              {
                max: 100,
                message:
                  "Votre nom de compte doit faire 100 caractères maximum.",
              },
            ]}
          >
            <Input className="auth-input" placeholder="Tesla" />
          </Form.Item>

          <Form.Item style={{ textAlign: "left", marginTop: "20px" }}>
            <Button
              className="submit-link"
              htmlType="submit"
              loading={loading}
              size="large"
            >
              Sauvegarder
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default AdminAccount;
